import React from "react";
import ReactStars from "react-rating-stars-component";

import { Col, Row } from "react-bootstrap";
import { MdStar, MdStarHalf, MdStarOutline, MdVerified } from "react-icons/md";
const SingleReview = ({ review }) => {
  const name = review?.user?.name;
  return (
    <Row className="border-top py-5">
      <Col md={3} className="border-end">
        <div>
          <div className="">Product Reviews</div>
          <MdVerified /> Verified Customer
        </div>
        <div>{review?.user?.name ? name : ""}</div>
      </Col>
      <Col md={9} className="ps-4">
        {/* <div className="d-flex align-items-center justify-content-start">
          <MdStar />
          <MdStar />
          <MdStar />
          <MdStarHalf />
          <MdStarOutline />
        </div> */}
        <ReactStars
          count={5}
          edit={false}
          size={24}
          activeColor="#ffd700"
          value={review?.rating}
        />

        <div className="mt-3" style={{ fontSize: "0.9375rem" }}>
          {review?.description}
        </div>

        <div
          className="d-flex align-items-center justify-content-end mt-3"
          style={{ fontSize: "0.75rem" }}
        >
          {/* <div className="d-flex align-items-center">
            Was this review helpful?
            <span className="text-decoration-underline ms-2">Yes</span>
            <span className="text-decoration-underline ms-2">Report</span>
          </div> */}
          <span>{new Date(review?.createdAt).toLocaleDateString()}</span>
        </div>
      </Col>
    </Row>
  );
};

export default SingleReview;
